import { Box, Typography } from '@mui/material';
import { HelmetHeader } from 'components/HelmetHeader';
import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import ConfusedDog from '../assets/confused-dog.webp';
const About = lazy(() => import('./About').then((m) => ({ default: m.About })));
const ContactUs = lazy(() => import('./ContactUs').then((m) => ({ default: m.ContactUs })));
const FAQS = lazy(() => import('./FAQS').then((m) => ({ default: m.FAQS })));
const Home = lazy(() => import('./Home').then((m) => ({ default: m.Home })));
const Memorials = lazy(() => import('./Memorials').then((m) => ({ default: m.Memorials })));
const Pricing = lazy(() => import('./Pricing').then((m) => ({ default: m.Pricing })));
const Privacy = lazy(() => import('./Privacy').then((m) => ({ default: m.Privacy })));
const Resources = lazy(() => import('./Resources').then((m) => ({ default: m.Resources })));
const Services = lazy(() => import('./Services').then((m) => ({ default: m.Services })));
const TermsAndConditions = lazy(() => import('./TermsAndConditions').then((m) => ({ default: m.TermsAndConditions })));
const Testimonials = lazy(() => import('./Testimonials').then((m) => ({ default: m.Testimonials })));
const Time = lazy(() => import('./Time').then((m) => ({ default: m.Time })));

export const baseUrl = 'https://passingpawsihe.com/';

// Update sitemap before altering these
export enum Paths {
    about = 'about',
    memorials = 'memorials',
    testimonials = 'testimonials',
    time = 'how-do-i-know-its-time',
    services = 'services',
    pricing = 'pricing',
    resources = 'resources',
    faqs = 'faqs',
    contact = 'contact',
    //appointment = 'appointment',
    appointmentFullUrl = 'https://passingpawsihe.simpledvm.com/form/de4ebcba-d18b-40f5-bf63-083c6b98848e',
    privacy = 'privacy',
    terms = 'terms',
}

export const navItems = [
    { title: 'About Me', path: Paths.about },
    { title: 'Pet Memorials', path: Paths.memorials },
    { title: 'Testimonials', path: Paths.testimonials },
    { title: "How Do I Know It's Time?", path: Paths.time },
    { title: 'Services', path: Paths.services },
    { title: 'Pricing', path: Paths.pricing },
    { title: 'Resources', path: Paths.resources },
    { title: 'FAQS', path: Paths.faqs },
    { title: 'Contact', path: Paths.contact },
    { title: 'Privacy', path: Paths.privacy },
    { title: 'Terms And Conditions', path: Paths.terms },
    { title: 'Appointment', path: Paths.appointmentFullUrl },
];

const routeComponents: Record<string, React.LazyExoticComponent<() => JSX.Element>> = {
    [Paths.about]: About,
    [Paths.memorials]: Memorials,
    [Paths.testimonials]: Testimonials,
    [Paths.time]: Time,
    [Paths.services]: Services,
    [Paths.pricing]: Pricing,
    [Paths.resources]: Resources,
    [Paths.faqs]: FAQS,
    [Paths.contact]: ContactUs,
    [Paths.privacy]: Privacy,
    [Paths.terms]: TermsAndConditions,
};

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <Suspense fallback={<div>Loading...</div>}>
                <Home />
            </Suspense>
        ),
    },
    ...navItems
        .filter((ni) => ni.title !== 'Appointment')
        .map((item) => ({
            path: item.path,
            element: <Suspense fallback={<div>Loading...</div>}>{React.createElement(routeComponents[item.path])}</Suspense>,
        })),
    {
        path: '*',
        element: (
            <main id="main">
                <HelmetHeader
                    title={'404'}
                    description="Page not found"
                />
                <Box sx={{ margin: 10 }}>
                    <Typography variant="h4">Uh oh! Looks like you got lost. Try going back or using one of the links on this page.</Typography>
                    <img
                        src={ConfusedDog}
                        alt="Confused dog."
                        height={400}
                    />
                </Box>
            </main>
        ),
    },
]);

export const ExcludedLinksInLists = [Paths.appointmentFullUrl, Paths.privacy, Paths.terms];
